<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table class="page" id="preview-charge-account"
        *ngFor=" let  chargeAccountModel of chargeAccountModels; trackBy: trackByChargeAccountId"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart($event)">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{chargeAccountModel.invoiceId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{chargeAccountModel.invoiceId}}" [src]="logoEnterprise" alt="" draggable="false">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{chargeAccountModel.invoiceId}}">
                    {{chargeAccountModel.enterpriseName}}</p>

                  <!--Nit  -->
                  <label id="t-nit-empresa-{{chargeAccountModel.invoiceId}}" for="">{{'t-nit-empresa' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="nit-empresa-{{chargeAccountModel.invoiceId}}">
                    {{chargeAccountModel.enterpriseNit}}
                  </p>

                  <!-- Dirección -->
                  <label id="t-direccion-{{chargeAccountModel.invoiceId}}" for="">{{'t-direccion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-{{chargeAccountModel.invoiceId}}">
                    {{chargeAccountModel.addressBranch}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{chargeAccountModel.invoiceId}}" for="">{{'t-telefono' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="telefono-{{chargeAccountModel.invoiceId}}">
                    {{chargeAccountModel.phoneBranch}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{chargeAccountModel.invoiceId}}" for="">{{'t-cliente' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="cliente-{{chargeAccountModel.invoiceId}}">
                    {{chargeAccountModel.clientNitName1}}</p>

                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{chargeAccountModel.invoiceId}}" for="">{{'t-centro-costos' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="centro-costos-{{chargeAccountModel.invoiceId}}" *ngIf="chargeAccountModel.costCenterId"
                    (click)="onClick()">
                    {{chargeAccountModel.costCenterCodeName}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-cliente-{{chargeAccountModel.invoiceId}}">{{'t-direccion-cliente' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-cliente-{{chargeAccountModel.invoiceId}}">
                    {{ chargeAccountModel.clientAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-cliente-{{chargeAccountModel.invoiceId}}">{{'t-telefono-cliente' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-cliente-{{chargeAccountModel.invoiceId}}">
                    {{chargeAccountModel.clientPhone}}</p>

                  <!--titulo-cuenta-cobro  -->
                  <p id="titulo-cuenta-cobro-{{chargeAccountModel.invoiceId}}">CUENTA DE COBRO</p>

                  <!--consecutivo-cuenta-cobro  -->
                  <p id="consecutivo-cuenta-cobro-{{chargeAccountModel.invoiceId}}">{{chargeAccountModel.consecutive}}
                  </p>

                  <!-- Forma de pago  -->
                  <label id="t-forma-pago-{{chargeAccountModel.invoiceId}}">{{'t-forma-pago' | formatLabelPipe :
                    elementsLabel}}</label>

                  <!-- Fecha Emisión  -->
                  <label id="t-fecha-emision-{{chargeAccountModel.invoiceId}}">{{'t-fecha-emision' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="fecha-emision-{{chargeAccountModel.invoiceId}}">
                    {{chargeAccountModel.dateInvoice | date: 'dd/MM/yyyy'}}</p>

                  <!-- Fecha Vencimiento  -->
                  <label id="t-fecha-vencimiento-{{chargeAccountModel.invoiceId}}">{{'t-fecha-vencimiento' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-vencimiento-{{chargeAccountModel.invoiceId}}">
                    {{chargeAccountModel.dateExpiration | date: 'dd/MM/yyyy'}}</p>

                  <p id="trafico-{{chargeAccountModel.invoiceId}}">{{chargeAccountTraffic == '' ? 'ORIGINAL CLIENTE' :
                    chargeAccountTraffic}}</p>

                  <!-- Periodo  -->
                  <label id="t-periodo-{{chargeAccountModel.invoiceId}}">{{'t-periodo' | formatLabelPipe :
                    elementsLabel}}
                  </label>
                  <p id="periodo-{{chargeAccountModel.invoiceId}}">{{chargeAccountModel.movementId ?
                    ((chargeAccountModel.rentalPeriodInitial | date: 'dd/MM/yyyy') + ' - ' +
                    (chargeAccountModel.rentalPeriodFinal | date: 'dd/MM/yyyy' )): '' }}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <p-table [value]="chargeAccountModel.chargeAccountDetails" dataKey="invoiceDetailId" [columns]="columns"
                  [reorderableColumns]="editFormat" (onColReorder)="onColumnReorder()"
                  [rowGroupMode]="formatModel.group ? 'subheader' : undefined"
                  [groupRowsBy]="formatModel.group ? 'conceptInvoicingId' : undefined"
                  [sortField]="formatModel.group ? 'conceptInvoicingId' : undefined" sortMode="single"
                  styleClass="p-datatable-sm" showGridlines>
                  <ng-template #header pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns; trackBy: trackByColumnField" pReorderableColumn
              [id]="'th-' + idMap[col.field].id + '-' + chargeAccountModel.invoiceId" (click)="clickTable($event)"
              [class]=" idMap[col.field].id">
              {{ col.header }}
            </th>
          </tr>
          </ng-template>
          <ng-template #body pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td *ngFor="let col of columns; trackBy: trackByColumnField"
                [id]="'td-' + idMap[col.field].id + '-' + rowData.id" (click)="clickTable($event)">
                {{rowData[col.field] | dynamicFormatPipe: idMap[col.field].type : idMap[col.field].printFormat}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="groupfooter" let-detail>
            <tr class="row-group-footer">
              <td [attr.colspan]="columns.length">
                <div class="summary-flex-container"
                  *ngIf="(groupDataMap() | groupInfoPipe: chargeAccountModel.invoiceId : detail.conceptInvoicingId) as info">
                  <!-- Concepto y valor total -->
                  <p id="foot-group-concept-{{chargeAccountModel.invoiceId}}" (click)="onClick()" class="group-concept">
                    {{ info.conceptName }}
                    <ng-container
                      *ngIf="labelPrintFormatMap['foot-group-concept'] as formatConcept; else currencyFormatGroupConcept">
                      {{ info.valueWithDiscount |
                      dynamicFormatPipe:'decimal':formatConcept}}
                    </ng-container>
                    <ng-template #currencyFormatGroupConcept>
                      {{ info.valueWithDiscount | currency }}
                    </ng-template>
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
          </p-table>
    </div>
    <div id="container-totals">
      <div id="totals">
        <div class="row d-flex justify-content-start totalRegContainer">
          <!-- Total registros -->
          <p id="foot-total-reg-{{chargeAccountModel.invoiceId}}" class="totalReg" (click)="onClick()">
            Total Reg: {{totalRegDetail}}
          </p>
        </div>

        <!-- subtotal -->
        <div class="row d-flex justify-content-end">
          <label id="foot-t-subtotal-{{chargeAccountModel.invoiceId}}" for="" class="">{{'foot-t-subtotal'
            | formatLabelPipe : elementsLabel}}</label>

          <p id="foot-subtotal-{{chargeAccountModel.invoiceId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-subtotal'] as formatSubtotal; else currencyFormatSubtotal">
              {{ chargeAccountModel.subtotalValue | dynamicFormatPipe:'decimal': formatSubtotal }}
            </ng-container>
            <ng-template #currencyFormatSubtotal>
              {{ chargeAccountModel.subtotalValue | currency }}
            </ng-template>
          </p>
        </div>

        <!-- Descuento general -->
        <div class="row d-flex justify-content-end">
          <label id="foot-t-dcto-gral-{{chargeAccountModel.invoiceId}}" for="" class="">{{'foot-t-dcto-gral' |
            formatLabelPipe :
            elementsLabel}}</label>

          <p id="foot-dcto-gral-{{chargeAccountModel.invoiceId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-dcto-gral'] as formatDctoGral; else currencyFormatDctoGral">
              {{ chargeAccountModel.discountValue | dynamicFormatPipe:'decimal': formatDctoGral }}
            </ng-container>
            <ng-template #currencyFormatDctoGral>
              {{ chargeAccountModel.discountValue | currency }}
            </ng-template>
          </p>
        </div>

        <!-- total -->
        <div class="row d-flex justify-content-end">
          <label id="foot-t-total-{{chargeAccountModel.invoiceId}}" for="" class="">{{'foot-t-total' | formatLabelPipe :
            elementsLabel}}</label>
          <p id="foot-total-{{chargeAccountModel.invoiceId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-total'] as formatTotal; else currencyFormatTotal">
              {{ chargeAccountModel.totalValue | dynamicFormatPipe:'decimal':formatTotal }}
            </ng-container>
            <ng-template #currencyFormatTotal>
              {{ chargeAccountModel.totalValue | currency }}
            </ng-template>
          </p>
        </div>

        <div class="row pt-1">
          <p id="foot-totals-in-letters-{{chargeAccountModel.invoiceId}}" (click)="onClick()">
            Valor en letras: {{chargeAccountModel.totalValueInLetters}}</p>
        </div>

      </div>
    </div>
    <div id="foot-{{chargeAccountModel.invoiceId}}" class="foot mt-1 container-observations">
      <!-- Observaciones Empresa -->
      <p id="observacion1-{{chargeAccountModel.invoiceId}}">
        {{chargeAccountModel.observation}}</p>
      <label id="t-observación-cuenta-cobro-{{chargeAccountModel.invoiceId}}"
        *ngIf="chargeAccountModel.observation">{{'t-observación-cuenta-cobro' |
        formatLabelPipe : elementsLabel}}</label>
      <p id="observación-cuenta-cobro-{{chargeAccountModel.invoiceId}}" *ngIf="chargeAccountModel.observation">
        {{chargeAccountModel.observation}}
      </p>

      <!-- Firma Emisor-->
      <img id="firma-{{chargeAccountModel.invoiceId}}" [src]="signatureEnterprise" alt="">
      <p id="linea-firma-emisor-{{chargeAccountModel.invoiceId}}" class="write-line large-line" (click)="onClick()"></p>
      <label id="t-firma-emisor-{{chargeAccountModel.invoiceId}}">{{'t-firma-emisor' | formatLabelPipe :
        elementsLabel}}</label>

      <!-- Firma receptor-->
      <p id="linea-firma-receptor-{{chargeAccountModel.invoiceId}}" class="write-line large-line" (click)="onClick()">
      </p>
      <label id="t-linea-receptor-{{chargeAccountModel.invoiceId}}">{{'t-linea-receptor' | formatLabelPipe :
        elementsLabel}}</label>
    </div>
    </td>
    </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="1">
          <div class="informationPrint d-flex">
            <!-- Versión-->
            <p class="fw-bold pe-4 ">{{version}}</p>

            <!-- Fecha Impresión-->
            <label class="fw-bold pe-2">Fecha: </label>
            <p class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>

            <!-- Hora Impresión-->
            <label class="fw-bold pe-2">Hora: </label>
            <p class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>

            <!-- Usuario Impresión-->
            <label class="fw-bold pe-2">Usuario: </label>
            <p class="pe-4"> {{userAuthenticated}}</p>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <div class="d-flex justify-content-center">
              <p class="mt-2 informationPrint">Documento generado con el Software Cervino Web de Altos Software SAS.
                Nit.811.022.121-1. www.altos-soft.com</p>
            </div>
          </div>
        </td>
      </tr>
    </tfoot>
    </table>
  </div>
  </div>
</section>